import React, { useState, useEffect } from "react";
import { Button } from "../ui/button";
import { useNavigate } from "react-router-dom";
import { Menu, ShoppingCart } from "lucide-react";
import logo from "../../assets/logo2.png";
import { useCart } from "../../context/CartContext";
import { useAuth } from "../../context/AuthContext";

export default function Navbar() {
  const navigate = useNavigate();
  const { cart } = useCart();
  const { user } = useAuth();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const cartItemCount = cart.reduce((sum, item) => sum + item.quantity, 0);

  const handleNavigate = (path) => {
    setIsMobileMenuOpen(false);
    navigate(path);
  };

  const handlesNavigate = (path, scrollToId) => {
    setIsMobileMenuOpen(false);
    const element = document.getElementById(scrollToId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
  };

  return (
    <header className="fixed top-0 w-full z-50 bg-gray-200 text-black backdrop-blur">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2 flex items-center justify-between w-full">
        <a href="/" className="flex items-center gap-2.5">
          <div className="w-9 h-9 bg-white rounded-full flex items-center justify-center overflow-hidden shadow-sm border border-gray-100 shrink-0">
            <img src={logo} alt="UCH" className="w-7 h-7 object-contain" />
          </div>
          <div className="hidden sm:block">
            <p className="font-bold text-gray-900 text-sm leading-tight">UCH Self Service</p>
            <p className="text-gray-500 text-[10px]">University College Hospital</p>
          </div>
        </a>
        <div className="flex items-center">
          <nav className="hidden md:flex space-x-3">
            <Button
              variant="ghost"
              className="text-black text-sm px-3"
              onClick={() => navigate("/")}
            >
              Home
            </Button>
            <Button
              variant="ghost"
              className="text-black text-sm px-3"
              onClick={() => handlesNavigate(window.location.pathname, "transaction")}
            >
              Transactions
            </Button>
            <Button
              variant="ghost"
              className="text-black relative text-sm px-3"
              onClick={() => navigate("/receipt")}
            >
              <ShoppingCart className="h-4 w-4" />
              {cartItemCount > 0 && (
                <span className="absolute -top-1 -right-1 bg-red-500 text-black text-xs rounded-full h-4 w-4 flex items-center justify-center">
                  {cartItemCount}
                </span>
              )}
            </Button>
            <Button
              className="bg-blue-500 hover:bg-blue-600 text-white text-sm px-4"
              onClick={() => navigate(user ? "/dashboard" : "/login")}
            >
              {user ? "Dashboard" : "Log In"}
            </Button>
          </nav>
          <Button
            variant="ghost"
            className="md:hidden text-black"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <Menu className="h-5 w-5" />
          </Button>
        </div>
      </div>
      {isMobileMenuOpen && (
        <div className="md:hidden w-full bg-gray-200 text-black py-3 px-4 sm:px-6">
          <div className="flex flex-col space-y-3">
            <Button
              variant="ghost"
              className="text-black justify-start text-sm"
              onClick={() => handleNavigate("/")}
            >
              Home
            </Button>
            <Button
              variant="ghost"
              className="text-black justify-start text-sm"
              onClick={() => handlesNavigate(window.location.pathname, "transaction")}
            >
              Transactions
            </Button>
            <Button
              variant="ghost"
              className="text-black justify-start relative text-sm"
              onClick={() => handleNavigate("/receipt")}
            >
              <ShoppingCart className="mr-2 h-4 w-4" /> Cart
              {cartItemCount > 0 && (
                <span className="absolute top-0 right-2 bg-red-500 text-black text-xs rounded-full h-4 w-4 flex items-center justify-center">
                  {cartItemCount}
                </span>
              )}
            </Button>
            <Button
              className="bg-blue-500 hover:bg-blue-600 text-white justify-start text-sm"
              onClick={() => handleNavigate(user ? "/dashboard" : "/login")}
            >
              {user ? "Dashboard" : "Log In"}
            </Button>
          </div>
        </div>
      )}
    </header>
  );
}